module.exports = __webpack_public_path__ + "img/warning.87bdfdb0.svg";